import styled from "@emotion/styled";

export const Container = styled.div`
  background-color: var(--alias-color-background-normal-alternative);
  min-height: calc(100vh - 64px);
  display: flex;
  flex-direction: column;
`;

export const WorkspaceListContainer = styled.div`
  box-sizing: border-box;
  padding: 80px 40px 120px 40px;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  gap: 80px;
  min-width: 480px;
  text-align: center;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
`;

export const TabContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

export const TabHeaderContainer = styled.div`
  box-sizing: border-box;
  padding: 0 24px;
  width: 100%;
  height: 40px;
  align-items: center;
  justify-content: center;
  display: flex;
  gap: 20px;
  border-bottom: 1px solid var(--alias-color-line-normal);
`;

export const TabItem = styled.div<{ selected: boolean }>`
  display: flex;
  flex-direction: column;
  ${(props) => props.selected && "border-bottom: 2px solid var(--alias-color-primary-normal);"}
  box-sizing: border-box;
  width: 246px;
  height: 40px;
  padding: 8px 12px;
  align-content: center;
  cursor: pointer;
`;


export const EmptyView = styled.div`
  margin-top: 40px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  text-align: center;
`;

export const BtnContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  align-self: stretch;
`;

export const Line = styled.div`
  height: 1px;
  width: 100%;
  background-color: var(--alias-color-line-normal);
`;
